import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

const EditTruckAssignmentModal = ({
  isOpen,
  onClose,
  selectedTruck,
  assignmentData,
  setAssignmentData,
  companies,
  filteredTrucks,
  filteredTrailers,
  filteredDrivers,
  onSubmit
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-base">
            Editar Asignación - Línea #{selectedTruck?.order}
          </DialogTitle>
        </DialogHeader>
        
        <div className="bg-blue-50 border border-blue-200 rounded-md p-2 text-xs text-blue-800">
          <strong>Nota:</strong> Puedes cambiar la empresa de transporte, patente del camión y chofer asignado.
        </div>
        
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-3">
            <div className="space-y-1">
              <Label className="text-xs font-medium">Empresa de Transporte</Label>
              <Select 
                value={assignmentData.company_id} 
                onValueChange={(v) => setAssignmentData({ 
                  ...assignmentData, 
                  company_id: v, 
                  truck_id: '', 
                  trailer_id: '', 
                  driver_id: '' 
                })}
              >
                <SelectTrigger className="h-9 text-sm">
                  <SelectValue placeholder="Seleccionar empresa" />
                </SelectTrigger>
                <SelectContent>
                  {companies.map(c => (
                    <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-1">
              <Label className="text-xs font-medium">Patente Camión</Label>
              <Select 
                value={assignmentData.truck_id} 
                onValueChange={(v) => setAssignmentData({ ...assignmentData, truck_id: v })} 
                disabled={!assignmentData.company_id}
              >
                <SelectTrigger className="h-9 text-sm">
                  <SelectValue placeholder="Seleccionar patente" />
                </SelectTrigger>
                <SelectContent>
                  {filteredTrucks.map(t => (
                    <SelectItem key={t.id} value={t.id}>{t.license_plate}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-1">
              <Label className="text-xs font-medium">Patente Acoplado (opcional)</Label>
              <Select 
                value={assignmentData.trailer_id} 
                onValueChange={(v) => setAssignmentData({ ...assignmentData, trailer_id: v })} 
                disabled={!assignmentData.company_id}
              >
                <SelectTrigger className="h-9 text-sm">
                  <SelectValue placeholder="Seleccionar acoplado" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Sin acoplado</SelectItem>
                  {filteredTrailers.map(t => (
                    <SelectItem key={t.id} value={t.id}>{t.license_plate}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-1">
              <Label className="text-xs font-medium">Chofer</Label>
              <Select 
                value={assignmentData.driver_id} 
                onValueChange={(v) => setAssignmentData({ ...assignmentData, driver_id: v })} 
                disabled={!assignmentData.company_id}
              >
                <SelectTrigger className="h-9 text-sm">
                  <SelectValue placeholder="Seleccionar chofer" />
                </SelectTrigger>
                <SelectContent>
                  {filteredDrivers.map(d => (
                    <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          
          <div className="flex gap-2 pt-2">
            <Button type="button" variant="outline" onClick={onClose} className="flex-1 h-9">
              Cancelar
            </Button>
            <Button 
              type="submit" 
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white h-9"
              disabled={!assignmentData.company_id || !assignmentData.truck_id || !assignmentData.driver_id}
            >
              Guardar Cambios
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditTruckAssignmentModal;
